import { Scaffold } from 'layouts';
import { ListStocks } from 'components/Pages/Stock/PaginatedStocks';
import { StockLayout } from 'layouts/Stock';

export const ListStockPage: React.FC = () => {
  return (
    <Scaffold>
      <StockLayout>
        <ListStocks />
      </StockLayout>
    </Scaffold>
  );
};
